/**
 * Created by zhangsanfeng on 2019/12/16.
 */

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
  tabs: [
    { pageMenu: '首页', index1: 0, index2: 0, pageUrl: '/home', active: true }
  ],
  tabActive: '0-0'
};
const getters = {
  getTabs(state) {
    return state.tabs;
  },
  getTabActive(state) {
    return state.tabActive
  }
};
const mutations = {
  setTabs(state, array) {
    state.tabs = array;
  },
  setTabActive(state, inx) {
    state.tabActive = inx;
  }
};
const actions = {
  setTabs(context, array) {
    context.commit('setTabs', array);
  },
  setTabActive(context, inx) {
    context.commit('setTabActive', inx);
  }
};
const store = new Vuex.Store({ state, getters, mutations, actions });
export default store;